<template>
	<div class="left-0 top-0 z-50 flex h-[calc(100vh-500px)] w-screen items-center justify-center bg-gradient-to-br from-white/10 via-black via-45% to-black">
		<div class="flex flex-col items-center justify-center">
			<div class="relative flex animate-pulse items-center justify-center rounded-full">
				<i class="fa-thin fa-spinner-third animate-spin text-2xl font-bold text-fury-orange-400"></i>
			</div>
		</div>
	</div>
</template>
